export default __webpack_public_path__ + "static/media/ic_manage-ftth.ba616a7d.svg";